import React, { createContext } from 'react';

import { useIndex } from '../hooks';

export const PeopleContext = createContext(null);

export function PeopleProvider({ query, children }) {
  const { data: people, loading } = useIndex('people', query);

  if (loading) {
    return (
      <div>Loading people...</div>
    );
  }
    
  return <PeopleContext.Provider value={{ people }}>{children}</PeopleContext.Provider>;
}